import { render, staticRenderFns } from "./role01.vue?vue&type=template&id=2e0e312e"
import script from "./role01.vue?vue&type=script&lang=js"
export * from "./role01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports